import { useEffect, useRef } from 'react';
import { HeroCollageSection, HeroCollageTorch } from './Background.styles';

const HeroCollage = (): JSX.Element => {
  const torchElement = useRef(null);

  const moveTorch = (event: any) => {
    if (!torchElement || !torchElement.current) return;

    const torch: HTMLElement = torchElement.current as any;
    const bbox = torch.getBoundingClientRect();

    const xCoordinate = event.clientX - bbox.left;
    const yCoordinate = event.clientY - bbox.top;

    if (!xCoordinate || !yCoordinate) return;

    torch?.style.setProperty(`--torchX`, `${xCoordinate}px`);
    torch?.style.setProperty(`--torchY`, `${yCoordinate}px`);
  };

  useEffect(() => {
    document.addEventListener('mousemove', moveTorch);
    return () => {
      document.removeEventListener('mousemove', moveTorch);
    };
  }, []);

  return (
    <HeroCollageSection>
      <HeroCollageTorch ref={torchElement} />
    </HeroCollageSection>
  );
};

export default HeroCollage;
